import switchFunc from 'lib/function/switchFunc'
import LineAppleIcon from 'LuxKit/Icons/line/LineAppleAltIcon'
import LineBathIcon from 'LuxKit/Icons/line/LineBathIcon'
import LineBedDoubleIcon from 'LuxKit/Icons/line/LineBedDoubleIcon'
import LineBusIcon from 'LuxKit/Icons/line/LineBusIcon'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'
import LineChairWithAirplaneIcon from 'LuxKit/Icons/line/LineChairWithAirplaneIcon'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import LineChildWithPlusIcon from 'LuxKit/Icons/line/LineChildWithPlusIcon'
import LineClochIcon from 'LuxKit/Icons/line/LineClochIcon'
import LineClockWithTickIcon from 'LuxKit/Icons/line/LineClockWithTickIcon'
import LineCoffeeIcon from 'LuxKit/Icons/line/LineCoffeeIcon'
import LineDelayIcon from 'LuxKit/Icons/line/LineDelayIcon'
import LineDiningCreditIcon from 'LuxKit/Icons/line/LineDiningCreditIcon'
import LineDollarSignIcon from 'LuxKit/Icons/line/LineDollarSignIcon'
import LineDrinksTrayIcon from 'LuxKit/Icons/line/LineDrinksTrayIcon'
import LineFireIcon from 'LuxKit/Icons/line/LineFireIcon'
import LineFlightCreditIcon from 'LuxKit/Icons/line/LineFlightCreditIcon'
import LineGlassMartiniAltIcon from 'LuxKit/Icons/line/LineGlassMartiniAltIcon'
import LineGlassMartiniIcon from 'LuxKit/Icons/line/LineGlassMartiniIcon'
import LineGolfIcon from 'LuxKit/Icons/line/LineGolfIcon'
import LineHappyHourIcon from 'LuxKit/Icons/line/LineHappyHourIcon'
import LineKidIcon from 'LuxKit/Icons/line/LineKidIcon'
import LineMobileAndroidIcon from 'LuxKit/Icons/line/LineMobileAndroidIcon'
import LineNoFeesIcon from 'LuxKit/Icons/line/LineNoFeesIcon'
import LineOneWayFlightIcon from 'LuxKit/Icons/line/LineOneWayFlightIcon'
import LineParkingCircleIcon from 'LuxKit/Icons/line/LineParkingCircleIcon'
import LineReceiptIcon from 'LuxKit/Icons/line/LineReceiptIcon'
import LineReturnFlightIcon from 'LuxKit/Icons/line/LineReturnFlightIcon'
import LineRoomUpgradeIcon from 'LuxKit/Icons/line/LineRoomUpgradeIcon'
import LineSkiLiftIcon from 'LuxKit/Icons/line/LineSkiLiftIcon'
import LineSnowFlakeIcon from 'LuxKit/Icons/line/LineSnowFlakeIcon'
import LineSpaCreditIcon from 'LuxKit/Icons/line/LineSpaCreditIcon'
import LineTagIcon from 'LuxKit/Icons/line/LineTagIcon'
import LineTaxiIcon from 'LuxKit/Icons/line/LineTaxiIcon'
import LineTennisBallIcon from 'LuxKit/Icons/line/LineTennisBallIcon'
import LineUtensilsIcon from 'LuxKit/Icons/line/LineUtensilsIcon'
import LineWaterIcon from 'LuxKit/Icons/line/LineWaterIcon'
import LineWellnessIcon from 'LuxKit/Icons/line/LineWellnessIcon'
import LineWifiIcon from 'LuxKit/Icons/line/LineWifiIcon'
import LineWifiRouterIcon from 'LuxKit/Icons/line/LineWifiRouterIcon'
import LineWineBeerIcon from 'LuxKit/Icons/line/LineWineBeerIcon'
import LineTvRetroIcon from 'LuxKit/Icons/line/LineTvRetroIcon'
import LineShowerIcon from 'LuxKit/Icons/line/LineShowerIcon'
import LineTreesIcon from 'LuxKit/Icons/line/LineTreesIcon'
import LineOvenIcon from 'LuxKit/Icons/line/LineOvenIcon'
import LineBoxIcon from 'LuxKit/Icons/line/LineBoxIcon'
import LineToasterIcon from 'LuxKit/Icons/line/LineToasterIcon'
import LineCookingPanIcon from 'LuxKit/Icons/line/LineCookingPanIcon'
import LineMicrowaveIcon from 'LuxKit/Icons/line/LineMicrowaveIcon'
import LineBlenderIcon from 'LuxKit/Icons/line/LineBlenderIcon'
import LineWashingMachineIcon from 'LuxKit/Icons/line/LineWashingMachineIcon'
import LineHairDryerIcon from 'LuxKit/Icons/line/LineHairDryerIcon'
import LineFridgeIcon from 'LuxKit/Icons/line/LineFridgeIcon'
import LineWindIcon from 'LuxKit/Icons/line/LineWindIcon'
import LineSunIcon from 'LuxKit/Icons/line/LineSunIcon'
import LineIronIcon from 'LuxKit/Icons/line/LineIronIcon'
import LineKettleIcon from 'LuxKit/Icons/line/LineKettleIcon'
import LineDesktopIcon from 'LuxKit/Icons/line/LineDesktopIcon'
import LineGlassIcon from 'LuxKit/Icons/line/LineGlassIcon'
import LineSanitizerIcon from 'LuxKit/Icons/line/LineSanitizerIcon'
import LineDumbbellIcon from 'LuxKit/Icons/line/LineDumbbellIcon'
import LineWheelchairIcon from 'LuxKit/Icons/line/LineWheelchairIcon'
import LineDryerIcon from 'LuxKit/Icons/line/LineDryerIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import LineSwimmerIcon from 'LuxKit/Icons/line/LineSwimmerIcon'
import type SvgIcon from 'LuxKit/SvgIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'
import LineUniversityIcon from 'LuxKit/Icons/line/LineUniversityIcon'
import LineMountainsRoadIcon from 'LuxKit/Icons/line/LineMountainsRoadIcon'
import LineSightseeingIcon from 'LuxKit/Icons/line/LineSightseeingIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineKeySkeletonAltIcon from 'LuxKit/Icons/line/LineKeySkeletonAltIcon'
import LinePricetagAltIcon from 'LuxKit/Icons/line/LinePricetagAltIcon'
import SolidKeySkeletonAltIcon from 'LuxKit/Icons/solid/SolidKeySkeletonAltIcon'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'

export const INCLUSION_ICONS: Record<App.OfferFeatureSymbol, typeof SvgIcon> = {
  apple: LineAppleIcon,
  bed_with_upwards_arrow: LineRoomUpgradeIcon,
  bus: LineBusIcon,
  car: LineCarIcon,
  check: LineCheckIcon,
  childs_face: LineKidIcon,
  childs_face_with_plus: LineChildWithPlusIcon,
  cloche: LineClochIcon,
  clock_with_check: LineClockWithTickIcon,
  clock_with_plus: LineDelayIcon,
  coffee_cup: LineCoffeeIcon,
  crossed_utensils: LineUtensilsIcon,
  crossed_utensils_with_plus: LineDiningCreditIcon,
  dollar_sign_in_circle: LineDollarSignIcon,
  dollar_sign_in_circle_with_line_through: LineNoFeesIcon,
  drink_tray: LineDrinksTrayIcon,
  golf: LineGolfIcon,
  lotus: LineWellnessIcon,
  lotus_with_plus: LineSpaCreditIcon,
  martini_glass: LineGlassMartiniAltIcon,
  p_in_circle: LineParkingCircleIcon,
  plane_with_arrow: LineOneWayFlightIcon,
  plane_with_arrows: LineReturnFlightIcon,
  plane_with_plus: LineFlightCreditIcon,
  plane_departure: LinePlaneDepartureIcon,
  receipt: LineReceiptIcon,
  seat_with_plane: LineChairWithAirplaneIcon,
  ski_lift: LineSkiLiftIcon,
  tag: LineTagIcon,
  taxi: LineTaxiIcon,
  tennis_ball: LineTennisBallIcon,
  wifi_signal: LineWifiIcon,
  wine_glass: LineGlassMartiniIcon,
  wine_glass_and_beer_glass: LineWineBeerIcon,
  wine_glass_with_clock: LineHappyHourIcon,
  ocean: LineWaterIcon,
  air_conditioning: LineSnowFlakeIcon,
  internet_connection: LineWifiRouterIcon,
  beach: LineWaterIcon,
  parking: LineParkingCircleIcon,
  king_size_bed: LineBedDoubleIcon,
  ensuite: LineBathIcon,
  heating: LineFireIcon,
  wifi: LineWifiIcon,
  tv: LineTvRetroIcon,
  pool: LineSwimmerIcon,
  toiletries: LineSanitizerIcon,
  shower: LineShowerIcon,
  garden: LineTreesIcon,
  underground_parking: LineParkingCircleIcon,
  terrace: LineTreesIcon,
  balcony: LineTreesIcon,
  bathtub: LineBathIcon,
  dining_area: LineUtensilsIcon,
  kitchen: LineOvenIcon,
  wardrobe: LineBoxIcon,
  toaster: LineToasterIcon,
  cook: LineCookingPanIcon,
  oven: LineOvenIcon,
  microwave: LineMicrowaveIcon,
  blender: LineBlenderIcon,
  washing_machine: LineWashingMachineIcon,
  hair_dryer: LineHairDryerIcon,
  fridge: LineFridgeIcon,
  coffee: LineCoffeeIcon,
  heat: LineFireIcon,
  wind: LineWindIcon,
  sun: LineSunIcon,
  iron: LineIronIcon,
  stereo: LineWifiRouterIcon,
  kettle: LineKettleIcon,
  desk: LineDesktopIcon,
  juice: LineGlassIcon,
  gym: LineDumbbellIcon,
  laundry: LineWashingMachineIcon,
  wheelchair: LineWheelchairIcon,
  dryer: LineDryerIcon,
  bed: LineBedDoubleIcon,
  stove: LineCookingPanIcon,
  cutlery: LineUtensilsIcon,
  breakfast: LineCoffeeIcon,
  washer: LineWashingMachineIcon,
  outdoor: LineTreesIcon,
  line_bed: LineBedIcon,
  line_room_upgrade: LineRoomUpgradeIcon,
  line_sightseeing: LineSightseeingIcon,
  line_university: LineUniversityIcon,
  line_mountains_road: LineMountainsRoadIcon,
  line_iconic_landmark: LineUniversityIcon,
  line_ship: LineShipIcon,
  line_usd_in_circle: LineUsdCircleIcon,
  line_check: LineCheckIcon,
  line_key_skeleton: LineKeySkeletonAltIcon,
  line_price_tag: LinePricetagAltIcon,
  key: SolidKeySkeletonAltIcon,
  beverage: LineGlassIcon,
  mobile_android: LineMobileAndroidIcon,
}

const iconsSwitch = switchFunc(INCLUSION_ICONS, LineCheckIcon)

function getOfferFeatureIcon(symbol: App.OfferFeatureSymbol | undefined): typeof SvgIcon {
  return iconsSwitch(symbol ?? '')
}

export default getOfferFeatureIcon
